export const CONTACT_PREFERENCES = {
    EMAIL: 'email',
    PHONE: 'phone',
    TEXT: 'text',
    NO_PREFERENCE: 'noPreference',
};
